export default "/images/1a31f15d47f72028cf57d946cbfdc0be.avif";